import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { NodeService } from '../../core/services/node';
import * as nodeActions from '../actions/nodes.action';

@Injectable()
export class NodeEffects {
  constructor(
    private actions$: Actions,
    private nodeService: NodeService,
  ) {}

  loadDownNodes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(nodeActions.LOAD_DOWN_NODES),
      switchMap(() =>
        this.nodeService.getDownNodes().pipe(
          map((nodes) => new nodeActions.LoadDownNodesSuccess(nodes)),
          catchError((error) => of(new nodeActions.LoadDownNodesFail(error))),
        ),
      ),
    ),
  );
}
